<template>
	<div>
		<HeadNav selectedLanguage="en" page="blog1" :gotodownload="gotodownload" :apk="apk" />
<div id="page" class="site grid-container container hfeed">
			<div id="content" class="site-content">
				<div id="primary" class="content-area">
					<main id="maincontent" class="site-main">
						<section id="section-1" class="section-content">
							<h1 class="section-1-blog-head">Why Is My Phone Not Downloading or Installing GB WhatsApp?
							</h1>

							<div class="lazy-picture-container writer-banner width-75" style="text-align: center">
								<picture>
									<img width="auto" height="auto" alt="GB WhatsApp not installing"
										src="../assets/blog-7.webp" />
								</picture>
							</div>

							<br />
							<p class="writter-content"><a class="jump-url" href="https://gbmodshub.com/">GB
									WhatsApp</a> has emerged as one of the most in-demand WhatsApp
								mods for Android users who want more than what the official app offers. Packed with
								unique features like interface customization, enhanced privacy controls, and the ability
								to use two accounts on a single device, GB WhatsApp gives users full control over their
								messaging experience—without limitations.</p>

							<h2 class="intro-title blog">Common Reasons GB WhatsApp Fails to Download or Install</h2>
							<p class="writter-content">There are several reasons why your device might block or fail to
								install GB WhatsApp. Below are the most common issues and step-by-step solutions:
							</p>

							<h2 class="intro-title blog">Installation from Unknown Sources Is Disabled</h2>
							<p class="writter-content">By default, Android phones block APK installations from unknown
								sources to protect against harmful apps.
								<br />
								<strong>How to fix:</strong>
							<ul>
								<li>Delete the old APK file</li>
								<li>Re-download GB WhatsApp from our <a class="jump-url"
										href="https://gbmodshub.com/download-devices/">GBWhatsApp download page</a>
								</li>
								<li>Make sure the download is fully complete before you tap "Install"</li>
								<li>Go to <strong>Settings > Apps > Special Access > Install Unknown Apps</strong></li>
								<li>Select your browser and toggle <strong>"Allow from this source"</strong></li>
							</ul>
							</p>

							<h2 class="intro-title blog">Corrupt or Incomplete APK File</h2>
							<p class="writter-content">
								<strong>How to fix:</strong>
							<ul>
								<li>Delete the old APK file</li>
								<li>Re-download GB WhatsApp from our GBWhatsApp download page</li>
								<li>Make sure the download is fully complete before you tap "Install"</li>
							</ul>
							</p>

							<h2 class="intro-title blog">Low Storage Space</h2>
							<p class="writter-content">Lack of storage space is a common reason installations fail
								silently or abruptly.
								<br />
								<strong>How to fix:</strong>
							<ul>
								<li>Go to <strong>Settings > Storage</strong> and check available space</li>
								<li>Delete unused apps, media files, or cached data</li>
								<li>Reboot your phone before attempting installation again</li>
							</ul>
							</p>

							<h2 class="intro-title blog">Android Version Not Supported</h2>
							<p class="writter-content">GB WhatsApp usually supports Android <strong>5.0
									(Lollipop)</strong> and above.
								Older versions may not support installation.
								<br />
								<strong>How to fix:</strong>
							<ul>
								<li>Check your Android version in <strong>Settings > About Phone</strong></li>
								<li>If possible, <strong>update your phone</strong> to a newer Android version</li>
								<li>Consider using a lighter WhatsApp mod if your device is outdated</li>
							</ul>
							</p>

							<h2 class="intro-title blog">Play Protect or Antivirus Blocking Installation</h2>
							<p class="writter-content">Google Play Protect may automatically block or uninstall
								unofficial APKs like GB WhatsApp.
								<br />
							<div style="width: 100%;display: flex;justify-content: center;">
								<picture>
									<img :style="{ height: '70vh', width: 'auto', objectFit: 'cover' }"
										alt="GB WhatsApp not installing" src="../assets/blog-7-1.webp" />
								</picture>
							</div>

							<br />
							<strong>How to fix:</strong>
							<ul>
								<li>Open the <strong>Play Store > Profile > Play Protect > Settings</strong></li>
								<li>Turn off <strong>"Scan apps with Play Protect"</strong></li>
								<li>If using antivirus software, whitelist GB WhatsApp or temporarily disable the
									antivirus</li>
							</ul>

							<!-- PC -->
							<div v-if="!isMobile" class="blog-7-img-list">
								<div class="img-item" v-for="(item, index) in imgList" :key="item">
									<picture>
										<img class="img" :src="item.img" alt="GB WhatsApp not installing"></img>
									</picture>
								</div>
							</div>

							<!-- 移动�?-->
							<div v-if="isMobile" class="blog-7-img-list-mobile">
								<div class="img-item" v-for="(item, index) in imgList" :key="item">
									<!-- <picture> -->
									<img class="img" :src="item.img" alt="GB WhatsApp not installing"></img>
									<!-- </picture> -->
								</div>
							</div>


							</p>

							<h2 class="intro-title blog">Conflicting App Package</h2>
							<p class="writter-content">If you already have the official WhatsApp installed, GB WhatsApp
								may conflict with it if it shares the same package name.
								<br />
								<strong>How to fix:</strong>
							<ul>
								<li><strong>Backup your chats</strong> from official WhatsApp</li>
								<li>Uninstall the official app</li>
								<li>Install GB WhatsApp using the downloaded APK</li>
								<li>Alternatively, use a <strong>clone version</strong> of GB WhatsApp with a different
									package name
									(e.g., com.gbwhatsapp)</li>
							</ul>
							</p>

							<h2 class="intro-title blog">Final Thoughts</h2>
							<p class="writter-content">Installing GB WhatsApp on your Android device requires a few
								extra steps compared to Play Store apps. If your phone isn't cooperating, don't
								worry—most issues can be resolved by adjusting a few settings or downloading the correct
								file version.
								<br />
								<br />
								Always download APKs from trusted websites, and be cautious when disabling system
								protections like Play Protect. Once set up properly, <strong>GB WhatsApp can transform
									your
									messaging experience</strong> with unmatched customization and control.
							</p>

							<Carousel />
						</section>
					</main>
				</div>
			</div>
		</div>

		<div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
			Download GBWhatsapp APK
		</div>
	</div>
</template>

<script>
import '@/css/base.scss'
import HeadNav from '@/components/HeadNav.vue'
import Carousel from '@/components/Carousel.vue'
import doc from '@/documents/blogs.js'
export default {
	name: 'Home',
	components: {
    HeadNav,
    Carousel,
  },
	data() {
		return {
			isMobile: false,
			pageName: 'home',
			selectedLanguage: 'en',
			doc: doc,
			showapk: false,
			apk: null,
			from: 'gb',
			filename: 'gb',
			imgList: [
				{
					index: '7-2',
					img: require('@/assets/blog-7-2.webp'),
				},
				{
					index: '7-3',
					img: require('@/assets/blog-7-3.webp'),
				},
				{
					index: '7-4',
					img: require('@/assets/blog-7-4.webp'),
				},
				{
					index: '7-5',
					img: require('@/assets/blog-7-5.webp'),
				},
				{
					index: '7-6',
					img: require('@/assets/blog-7-6.webp'),
				},
			],
			relatedPosts: [
				{
					image: require('@/assets/uninstall-gbwhatsapp.webp'),
					title: 'Related Post Title 1',
					description: 'Brief description of the related post. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
				},
				{
					image: require('@/assets/uninstall-gbwhatsapp.webp'),
					title: 'Related Post Title 2',
					description: 'Brief description of the related post. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
				},
			],
		}
	},
	computed: {
		breadcrumbs() {
			return this.$route.matched.reduce((acc, route) => {
				const crumbs = route.meta.breadcrumb || []
				return acc.concat(crumbs)
			}, [])
		},
	},
	mounted() {
		this.checkScreenSize();
		this.from = this.$global.GetQueryString('from') || this.from
		this.filename = this.$global.GetQueryString('filename') || this.filename
		console.log(this.$global.GetQueryString('from'))
		if (this.$global.GetQueryString('from')) {
			this.getAPK()
		} else {
			this.getOfficalApk()
		}
	},
	methods: {
		checkScreenSize() {
			this.isMobile = window.innerWidth < 768;
		},
		downloadfrom(reason) {
			this.download()
			this.$logEvent(`download_from_${reason}`, 'download')
			// window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
		},
		getAPK() {
			this.$server
				.getAPPInfo({
					promotionChannel: this.from,
					promotionName: this.filename,
				})
				.then((res) => {
					console.log(res)
					if (res.code == 200) {
						this.apk = res.data.apk
					} else {
						this.apk = process.env.VUE_APP_GBLINK
					}
				})
		},
		getOfficalApk(type = 1, domain = null, appname = null) {
			this.$server
				.getOfficalApk({
					domain: domain || 'gbwhatsapp.chat',
					appName: appname || 'GB_gbwhatsapp.chat',
				})
				.then((res) => {
					console.log(res)
					if (res.code == 200) {
						if (type == 1) {
							this.apk = res.data.apk
						}
						this.lastupdate = res.data.promotion.updateTime
						this.votes = res.data.promotion.totalCount
						this.rating = res.data.promotion.score
						console.log('apk getted')
					} else {
						this.apk = process.env.VUE_APP_GBLINK
					}
				})
		},
		gotodownload() {
			console.log(this.apk)
			// this.showapk = true
			if (this.apk) {
				this.$global.download(this.apk)
			}
		},
		jump(url) {
			window.location.href = url
		},
		goto(page) {
			this.$router.push({
				name: `${this.selectedLanguage}-${page}`,
			})
		},
	},
}
</script>
<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100% !default;

// pc
.blog-7-img-list {
	display: flex;
	justify-content: center;
	gap: 10px;
	.img-item {
		.img {
			height: 50vh;
			width: auto;
			object-fit: cover;
		}

	}
}

// mobile
.blog-7-img-list-mobile {
	// width: 80vw;
	overflow-x: scroll;
	display: flex;
	// justify-content: center;
	gap: 10px;
	.img-item {
		flex-shrink:0;
		.img {
			height: 50vh;
			width: auto;
			object-fit: cover;
		}

	}

}

.blog1-container {
	max-width: 1200px;
	margin: 0 auto;
	padding: 0 20px;
	/* 小屏幕左右边�?*/
}

.main-content {
	flex: 2;
	margin-right: 30px;
	background: #f7f7f7;
	padding: 20px;
	border-radius: 10px;
}

.related-posts {
	flex: 1;
	/* �?/3宽度 */
}

.blog1-container {
	display: flex;
	gap: 30px;
	/* 列间�?*/
	margin-top: 40px;
}

/* 文章主体样式 */
.blog-title {
	font-size: 2.5rem;
	margin-bottom: 15px;
	line-height: 1.2;
	font-weight: 700;
}

.author-info {
	display: flex;
	gap: 15px;
	font-size: 0.95rem;
	color: #666;
	margin-bottom: 20px;
}

ul li::marker {
	color: #025cd8;
}

.download-btn {
	padding: 20px;
	background-color: #025cd8;
	color: white;
	border: none;
	border-radius: 8px;
	cursor: pointer;
	margin: 15px 0;
	font-size: 20px;
	display: inline-block;
}

.content-divider {
	border: 0;
	height: 1px;
	background-color: #eee;
	margin: 30px 0;
}

.article-content {
	line-height: 1.6;
	font-size: 1.05rem;
}

/* 相关文章样式 */
/* 优化后的相关文章样式 */
.related-post-item {
	display: flex;
	gap: 20px;
	padding: 15px 0;
	border-bottom: 1px solid #ccc;
	cursor: pointer;
}

.related-post-thumb {
	/* width: 100px; */
	height: 80px;
	object-fit: cover;
	border-radius: 4px;
	flex-shrink: 0;
}

.related-post-content {
	flex: 1;
	display: flex;
	flex-direction: column;
}

.related-post-title {
	font-size: 1.1rem;
	margin-bottom: 8px;
	white-space: nowrap;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
}

.related-post-desc {
	color: #666;
	line-height: 1.5;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}

.related-post-divider {
	border: 0;
	border-top: 1px solid #eee;
	margin: 0;
}

.author {
	display: flex;
	/* padding: 40px; */
	max-width: 1000px;
	gap: 30px;
	margin: 30px auto;
	background: #f2fff6;
	border-radius: 12px;
	box-shadow: 0 2px 5px #ccc;
	/* align-items: center; */
}

.author-avatar {
	border-radius: 12px 0 0 12px;
	height: 100%;
}

.author-right-info {
	flex: 1;
	padding-right: 20px;
}

.author-olivia {
	padding: 20px 0;
}

/* 响应式调�?*/
@media (max-width: 992px) {
	.blog1-container {
		flex-direction: column;
		gap: 40px;
	}

	.author {
		flex-direction: column;
		padding: 10px;
		margin: 20px;
		gap: 0;
	}

	.main-content,
	.related-posts {
		flex: none;
		width: 100%;
	}
}
</style>
